<template>
  <div class="ui center aligned basic segment" id="screen" style="overflow:auto;display:flex;margin:0">
    <div class="ui center aligned container purple segment" style="display:inline-block;margin:auto">
      <h3 class="header">Vehicle photo shoots with errors</h3>
      <div class="ui divided items" style="text-align:left">
        <div class="item" v-for="(mp,index) in mps" :key="index">
          <div class="content">
            <div class="ui header">{{ new Date(mp.created).toLocaleString() }}</div>
            <div class="meta">by {{ mp.createdby }}</div>
            <div class="meta">Error: {{ mp.error }}</div>
            <div class="description">
              <button class="ui red button" @click="deleteMP(index)">Delete record</button>
              <div class="ui header">Plate photo:</div>
              <div class="ui medium image" style="display:flex;flex-direction:column">
                <img :src="$host+'/img/'+mp.plate+'/'+mp.plate+'.jpg'">
                <div class="ui input">
                  <input type="text" v-model="mp.reg" placeholder="-- type registration --">
                </div>
              </div>
              <div style="margin:1em">
                <button v-if="mp.reg && mp.reg != ''" class="ui primary button" @click="saveMP(index)">Save</button>
              </div>
              <div class="ui header">Photos:</div>
              <div class="ui fluid stackable four cards">
                <div class="card" v-for="(r, index) in mp.ids" :key="index">
                  <div class="image">
                    <img :src="$host+'/img/'+mp.plate+'/'+r+'.jpg'">
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        mps:[],
        dts:{
          ps:20,
          skip:0
        }
      };
    },
    methods: {
      saveMP(index) {
        var thiz = this;
        fetch(this.$host+'/savemp', {
          method:'POST',
          headers: {'Content-type':'application/json'},
          credentials:'include',
          mode:'cors',
          body: JSON.stringify({mp:this.mps[index]})
        }).then(res=>res.json()).then(res=>{
          if (res.error) {
            console.log('application error #68', res);
          }
          else {
            thiz.loadManualShoots();
          }
        }).catch(err=>{
          console.log('system error #73', err);
        });
      },
      deleteMP(index){
        var thiz = this;
        if (confirm('Are you sure, you want to delete this photo shoot?')) {
          fetch(this.$host+'/deletemp', {
            method:'POST',
            headers: {'Content-type':'application/json'},
            credentials:'include',
            mode:'cors',
            body: JSON.stringify({id:this.mps[index]._id})
          }).then(res=>res.json()).then(res=>{
            if (res.error) {
              console.log('application error #66', res);
            }
            else {
              thiz.loadManualShoots();
            }
          }).catch(err=>{
            console.log('system error #73', err);
          });
        }
      },
      loadManualShoots() {
        var thiz = this;
        fetch(this.$host+'/mps', {
          method:'POST',
          headers:{'Content-type':'application/json'},
          body:JSON.stringify(this.dts),
          credentials:'include',
          mode:'cors'
        }).then(res=>res.json()).then(res=>{
          if (res.error) {
            console.log('application error #24', res);
          }
          else {
            thiz.mps = res.mps;
          }
        }).catch(err=>{
          console.log('system error #25', err);
        });
      }
    },
    mounted() {
      setTimeout(()=>{
        const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
        e.onfinish = ()=>{
          document.querySelector('#purpleheader').style.height = "130px";
        };
      },0);
      this.loadManualShoots();
    }
  }
</script>
